import * as Yup from 'yup'

import { pin } from 'utils/yup'

export const LOCK_ENGINE_SCHEMA = Yup.object().shape({ pin })
